import { MapContext } from "helpers/map";
import { CSSProperties, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./layer-switch.module.scss";
import { ClickAwayListener, Tooltip } from "@mui/material"

interface LayerSwitchProps {
	map?: AMap.Map;
	style?: CSSProperties;
}

export default function LayerSwitch({ map: mapProp, style: propStyle }: LayerSwitchProps) {
	const [show, setShow] = useState<boolean>(false);
	const [current, setCurrent] = useState<string>("normal");

	const [satellite, setSatellite] = useState<AMap.TileLayer | null>(null);
	const [roadNet, setRoadNet] = useState<AMap.TileLayer | any>(null);

	const { AMap, map: mapContext } = useContext(MapContext);
	const map = mapProp || mapContext;

	const style: string[] = ["normal", "light", "dark", "fresh", "satellite"]; //, "roadnet"

	const [t] = useTranslation();

	const expand = (): void => {
		setShow(!show);
	};

	const changeLayer = (item: string): void => {
		setCurrent(item);
		setShow(false);
		if (item === "roadnet") {
			if (roadNet) {
				map.remove(roadNet);
				setRoadNet(null);
				return;
			}
			const rn = new AMap.TileLayer.RoadNet();
			setRoadNet(rn);
			map.add(rn);
			return;
		}
		if (satellite) {
			map.remove(satellite);
			setSatellite(null);
		}
		if (item === "satellite") {
			const satellite = new AMap.TileLayer.Satellite({ zIndex: 1 });
			map.add(satellite);
			setSatellite(satellite);
			return;
		}
		const styleName = "amap://styles/" + item;
		map.setMapStyle(styleName);
	};

	return (
		<ClickAwayListener onClickAway={() => setShow(false)}>
			<div className={styles.screen} style={propStyle}>
				<Tooltip title={t("layerSwitch.Map Styles")} placement="top">
					<button
						type="button"
						className={styles.trigger}
						onClick={expand}
					>
						<img
							// title={t("layerSwitch.Map Styles")}
							alt={current}
							src={`/icon/layer_icon_${current}.png`}
						/>
					</button>
				</Tooltip>
				{show && (<div
					className={styles.download}
				>
					{style &&
						style.map((item, index) => (
							<Tooltip
								key={item}
								title={t(`layerSwitch.${item}`)}
								placement="top"
							>
								<img
									// title={t(`layerSwitch.${item}`)}
									alt={item}
									src={`/icon/layer_icon_${item}.png`}
									key={index}
									onClick={() => changeLayer(item)}
								/>
							</Tooltip>
						))}
				</div>)}
			</div>
		</ClickAwayListener>
	);
}
